<template>
  <div id="ledger_accounts" v-bind:class="$mq">
    <div><b>Modified Accounts</b></div>

    <ul id="accounts">
      <li v-for="account in accounts" :key="account">
        <AccountLink v-bind:account="account" />
        <ul class="reasons">
          <li v-for="(tally, reason) in reasons[account]" :key="reason">
            {{reason.replace("(NUM)", tally)
                    .replace("(PLURAL)", tally > 1 ? 's' : '')}}
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import AccountLink    from './AccountLink.vue'

export default {
  name: 'LedgerOverview',

  components : {
    AccountLink
  },

  props : {
    ledger : Object
  },

  computed : {
    reasons : function(){
      var reasons = {};

      function add_reason(acct, reason){
        if(!reasons[acct])
          reasons[acct] = {};
        if(!reasons[acct][reason])
          reasons[acct][reason] = 0;
        reasons[acct][reason] += 1;
      }

      jsonpath.query(this.ledger, "$.transactions").forEach(function(tx){
          jsonpath.query(tx, "$..Account").forEach(function(acct){
            add_reason(acct, 'Submitted (NUM) TX(PLURAL)');
          });

          jsonpath.query(tx, "$..Destination").forEach(function(acct){
            add_reason(acct, 'Received (NUM) Payment(PLURAL)');
          });

          jsonpath.query(tx, "$..Owner").forEach(function(acct){
            add_reason(acct, 'Modified (NUM) Time(PLURAL)');
          });

          jsonpath.query(tx, "$..issuer").forEach(function(acct){
            add_reason(acct, 'IOU Modified (NUM) Time(PLURAL)');
          });
      });

      return reasons;
    },

    accounts : function(){
      return Object.keys(this.reasons).sort(function(a1, a2){
        var r1 = Object.values(this.reasons[a1]).reduce(function(r1, r2){ return r1 + r2; }, 0);
        var r2 = Object.values(this.reasons[a2]).reduce(function(r1, r2){ return r1 + r2; }, 0);
        return r2 - r1;
      }.bind(this));
    }
  }
}
</script>

<style scoped>
#ledger_accounts{
  background-color: white;
  padding: 10px;
  border-top: 1px solid #cccccc;
}

#accounts{
  list-style-type: none;
  max-height: 250px;
  overflow: auto;
}

.reasons{
  list-style-type: none;
}
</style>
